//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
  data(){
    return{
      set404:1,
      choose:[
        {
          label:'系统默认',
          value:1
        },
        {
          label:'404.asp',
          value:2
        },
        {
          label:'404.php',
          value:3
        },
        {
          label:'404.htm',
          value:4
        }
      ]
    }
  },
  mounted(){
    this.ErrorQuery()
  },
  methods: {
    Choose(id) {
      this.set404 = id
    },
    ErrorQuery() {
      let data = 'cmd=vhost_basic'+
        '&id='+ this.$route.params.id
      this.$http.post('https://api.abeiyun.com/www/vhost.php', data).then(({data}) => {
        if(data) {
          this.set404 = data.ErrPage ? Number(data.ErrPage.split('#')[1]) : 1
        }
      })
    },
    submit() {
      let data = 'cmd=page404_set'+
        '&id='+ this.$route.params.id +
        '&page404='+ this.set404
      let _this = this
      this.$http.post('https://api.abeiyun.com/www/vhost.php',data).then(({data})=>{
        if(data.response == 200 ) {
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }else{
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/console/hostoperate/Errorpage.vue